import React, { useCallback } from "react";

import { Avatar, Stack, Tooltip, Typography } from "@mui/material";
import { useSelectedBookmarkSelector } from "store";
import { IBookmark, UserLight } from "store/types";

import { getInitials } from "./bookmark-page";
import { getBookmarkPage } from "./bookmark-page";
import { useApplyBookmark } from "./use-apply-bookmark";

interface Props {
  bookmark: IBookmark;
  owner?: UserLight;
  onApplied: () => void;
}

export const SharedRow: React.FC<Props> = ({ bookmark, owner, onApplied }) => {
  const applyBookmark = useApplyBookmark();
  const selectedId = useSelectedBookmarkSelector();
  const page = getBookmarkPage(bookmark);
  const isActive = selectedId === bookmark.id;

  const handleClick = useCallback(() => {
    applyBookmark(bookmark);
    onApplied();
  }, [applyBookmark, bookmark, onApplied]);

  return (
    <Stack
      direction="row"
      alignItems="center"
      sx={{
        padding: "8px 24px",
        cursor: "pointer",
        backgroundColor: isActive ? "#dbe8f5" : "transparent",
        "&:hover": { backgroundColor: isActive ? "#dbe8f5" : "#ecf1f8" }
      }}
      onClick={handleClick}
    >
      <Stack sx={{ flex: 1, minWidth: 0 }}>
        <Typography
          sx={{
            fontSize: "16px",
            lineHeight: "24px",
            color: isActive ? "primary.main" : "#071f35",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
          }}
        >
          {bookmark.name}
        </Typography>
      </Stack>
      <Tooltip
        title={`Shared by ${owner?.full_name ?? "teammate"} · ${page.label}`}
        placement="left"
        arrow
        enterDelay={400}
      >
        <Avatar
          sx={{
            width: 24,
            height: 24,
            fontSize: "14px",
            fontWeight: 500,
            ml: "8px",
            flexShrink: 0,
            backgroundColor: "#ecf1f8",
            color: "#496682"
          }}
          src={owner?.profile_photo_url || undefined}
          imgProps={{ decoding: "async" }}
        >
          {getInitials(owner?.full_name)}
        </Avatar>
      </Tooltip>
    </Stack>
  );
};
